// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ClockIcon = /* @__PURE__ */ createIcon(
  'clock',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0M11 6a1 1 0 1 1 2 0v5.382l3.447 1.723a1 1 0 0 1-.894 1.79l-4-2A1 1 0 0 1 11 12zm12 6c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11',
      },
    ],
  ]
);
